import { useState } from "react";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { toast } from "./ui/sonner";
import { contact } from "../data/siteData";

export const InterestPhoneForm = ({ interest, source = "website", testId }) => {
  const [phone, setPhone] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const submitInterest = (event) => {
    event.preventDefault();
    setSubmitting(true);
    window.open(
      `${contact.managerWhatsapp}?text=${encodeURIComponent(
        [
          "Hi Club Manager, I want to register interest from kannursurfclub.in.",
          `Interest: ${interest}`,
          `Phone: ${phone}`,
          `Source: ${source}`,
        ].join("\n"),
      )}`,
      "_blank",
      "noopener,noreferrer",
    );
    toast.success("Opening WhatsApp with your interest details.");
    setPhone("");
    setSubmitting(false);
  };

  return (
    <form data-testid={`${testId}-form`} onSubmit={submitInterest} className="mt-6 grid gap-3 sm:grid-cols-[1fr_auto]">
      <Input
        data-testid={`${testId}-phone-input`}
        type="tel"
        required
        minLength={6}
        value={phone}
        onChange={(event) => setPhone(event.target.value)}
        placeholder="Phone number"
        className="h-11 rounded-xl border-white/15 bg-[#0A0F1C] text-white placeholder:text-slate-600 focus-visible:ring-[#FF5E3A]"
      />
      <Button
        data-testid={`${testId}-submit-button`}
        type="submit"
        disabled={submitting}
        className="h-11 rounded-xl bg-[#FFC059] px-5 font-bold uppercase tracking-[0.14em] text-[#0A0F1C] hover:bg-white disabled:opacity-60"
      >
        {submitting ? "Saving" : "Register Interest"}
      </Button>
    </form>
  );
};
